<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    <div class="col-xs-12">
      <div class="page-title">
        <div class="pull-left">
          <!-- PAGE HEADING TAG - START -->
          <h1 class="title">Request Details</h1>
          <!-- PAGE HEADING TAG - END -->
        </div>
      </div>
    </div>
    <div class="clearfix"></div>




    <div class="row">
      <div class="col-lg-6">
        <section class="box ">
          <div class="content-body">
            <div class="row">
              <div class="col-lg-6"><label>HospitalNo</label></div>
              <div class="col-lg-6">{{testRequest.HospitalNo}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Reference</label></div>
              <div class="col-lg-6">{{testRequest.Reference}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Attending doctor:</label></div>
              <div class="col-lg-6">{{testRequest.AttendingDr}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Account to</label></div>
              <div class="col-lg-6">{{testRequest.AccountTo}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Is grey</label></div>
              <div class="col-lg-6">{{testRequest.IsGrey}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Is fasting</label></div>
              <div class="col-lg-6">{{testRequest.IsFasting}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Sample date</label></div>
              <div class="col-lg-6">{{testRequest.SampleDate| date:'dd-MM-yyyy HH:mm'}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Request date</label></div>
              <div class="col-lg-6">{{testRequest.RequestDate | date:'dd-MM-yyyy HH:mm'}}</div>
            </div>
            <hr />
            <!--<div class="row">
              <div class="col-lg-1"><label>Tests</label></div>

                <div class="col-lg-1" *ngFor="let test of testRequest.Tests">
                  <span>{{test.TestCode}}</span>
                </div>
              
            </div>-->
            <div class="row">
              <!--<div class="col-lg-6"></div>-->
              <div class="col-lg-6">
                <input [disabled]="testRequest.LabNumber !== ''" type="button" (click)="downloadRequestPdf()" value="Download Request" class="btn btn-success form-control" />
              </div>
              <div class="col-lg-6">
                <a routerLink="/manage/request" [queryParams]="{id: Id}" class="btn btn-success form-control" >Request Again</a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-lg-6">
        <section class="box ">
          <div class="content-body">
            <div class="row">
              <div class="col-lg-6"><label>Forename </label></div>
              <div class="col-lg-6">{{testRequest.ForeName}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Surname</label></div>
              <div class="col-lg-6">{{testRequest.Surname}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Title</label></div>
              <div class="col-lg-6">{{testRequest.Title}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Sex</label></div>
              <div class="col-lg-6">{{testRequest.Sex}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>DOB</label></div>
              <div class="col-lg-6">{{testRequest.Dob | date:'dd-MM-yyyy'}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Phone</label></div>
              <div class="col-lg-6">{{testRequest.Phone}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Address1</label></div>
              <div class="col-lg-6">{{testRequest.Address1}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Address2</label></div>
              <div class="col-lg-6">{{testRequest.Address2}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>Address3</label></div>
              <div class="col-lg-6">{{testRequest.Address3}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label>PostCode</label></div>
              <div class="col-lg-6">{{testRequest.PostCode}}</div>
            </div>
            <div class="row">
              <div class="col-lg-6"><label> Email</label></div>
              <div class="col-lg-6">{{testRequest.Email}}</div>
            </div>
            </div>
        </section>
      </div>
    </div>
  </section>
</section>
